import '../../monitoring/filters/boolean_filter_view.js.coffee'

Namespace 'Profiling.Dashboard.Filters'

class Profiling.Dashboard.Filters.BooleanFilterView extends Monitoring.Views.SocialContents.Filters.BooleanFilterView
  initialize: ({searchQuery, title}) ->
    super(
      searchQuery: searchQuery
      title: title
      trueField: new Monitoring.Views.SocialContents.Filters.BooleanFilterViewField
        name: 'boolean_true'
        title: I18n.t('monitoring.taxonomy.y')
      falseField: new Monitoring.Views.SocialContents.Filters.BooleanFilterViewField
        name: 'boolean_false'
        title: I18n.t('monitoring.taxonomy.n')
    )

  _triggerQueryChanged: =>
    @searchQuery.triggerFilterChanged()
